import { Question } from '../types/form';

export const questions: Question[] = [
  {
    id: 'title',
    label: 'Title/Subject',
    description: 'What is the main topic or headline of your story?',
    example: 'A Memorable Family Vacation, Launching My First Startup',
    type: 'text',
    required: true
  },
  {
    id: 'date',
    label: 'Date',
    description: 'When did the story or key event take place?',
    example: '31 December 2024',
    type: 'date',
    required: true
  },
  {
    id: 'location',
    label: 'Location',
    description: 'Where did the event take place?',
    example: 'Enter the country and/or state',
    type: 'text',
    required: true
  },
  {
    id: 'department',
    label: 'People or Groups Involved',
    description: 'Who were the key individuals or groups involved in your story?',
    example: 'My family, our guide in Kyoto, the startup team',
    type: 'text',
    required: true
  },
  {
    id: 'objective',
    label: 'Purpose/Objective',
    description: 'Why is this story important to you or others? What inspired you to share it?',
    example: 'To document a life-changing journey, To inspire others with my startup story',
    type: 'textarea',
    required: true
  },
  {
    id: 'participants',
    label: 'Key Participants',
    description: 'Who were the most notable people in your story, and what roles did they play?',
    example: 'Grandma as the storyteller, mentor guiding my career transition',
    type: 'textarea',
    required: true
  },
  {
    id: 'description',
    label: 'What Happened?',
    description: 'Describe the main events or actions that form the core of your story.',
    example: 'We hiked to the summit of Mount Fuji, I pitched my idea to investors',
    type: 'textarea',
    required: true
  },
  {
    id: 'challenges',
    label: 'Challenges or Highlights',
    description: 'What were the most memorable moments, achievements, or difficulties in your story?',
    example: 'Overcoming fear of public speaking, Celebrating a milestone anniversary',
    type: 'textarea',
    required: true
  },
  {
    id: 'outcomes',
    label: 'Outcomes or Results',
    description: 'What were the results or conclusions of this event/activity?',
    example: 'Gained a new perspective on life, Secured funding for the project',
    type: 'textarea',
    required: true
  },
  {
    id: 'quotes',
    label: 'Quotes or Personal Reflections',
    description: 'Are there any quotes, feedback, or personal reflections?',
    example: 'This trip reminded me of what truly matters, said my sister',
    type: 'textarea',
    required: false
  },
  {
    id: 'takeaways',
    label: 'Key Takeaways',
    description: 'What are the main lessons or takeaways from your story?',
    example: 'Never underestimate the power of perseverance, Family time is priceless.',
    type: 'textarea',
    required: true
  }
];